import { TextBox } from 'devextreme-react';
import React from 'react';

export const FormInput = ({ field, form: { touched, errors, setFieldValue }, ...props }) => {
  const { col, label, onChange, required } = props;

  return (
    <div className={`col-lg-${col}`}>
      <div className={`form-group ${errors[field.name] ? 'has-error' : null}`}>
        <label className="control-label">
          {label}
          {required && <span className="text-danger"> * </span>}
        </label>
        <TextBox
          {...field}
          {...props}
          isValid={!errors[field.name]}
          onValueChanged={option => {
            setFieldValue(field.name, option ? option.value : '');

            onChange && onChange(option);
          }}
        />

        {touched[field.name] && errors[field.name] && (
          <span className="help-block m-b-none">{errors[field.name]}</span>
        )}
      </div>
    </div>
  );
};
